export default "__VITE_ASSET__7ca33fb2__"